import { Card } from '../ui/primitives';
import type { WhenView } from '../../utils/reports/whenView';
import { ReportsNotes, ReportsSay } from './ReportsParts';
import { ReportsBars, ReportsCardTitle, ReportsCaution, ReportsDetail, ReportsEmpty, ReportsSection, ReportsStats } from './ReportsPieces';

/**
 * P-084 · R4 «¿Cuándo vendo más?». Solo dibuja `WhenView`: la frase (y las razones cuando no se afirma un patrón),
 * cuatro cifras, las barras por día de la semana y por hora, y el detalle con los días de más ventas.
 */
export function ReportWhen({ view, onNavigate }: { view: WhenView; onNavigate: (destination: string) => void }) {
  if (view.empty) {
    return (
      <>
        <ReportsSay segments={view.say} />
        <ReportsEmpty description={view.empty.description} title={view.empty.title} />
        <ReportsNotes notes={view.notes} />
      </>
    );
  }
  return (
    <>
      <ReportsSay segments={view.say} />
      <ReportsCaution lines={view.caution} />
      <Card aria-labelledby="reports-when-stats" as="section">
        <h2 className="n3-visually-hidden" id="reports-when-stats">Operaciones, dinero, día y franja fuertes</h2>
        <ReportsStats stats={view.stats} />
        {view.comparison && <p className="n3-reports__comparison">{view.comparison}</p>}
      </Card>
      {view.weekdays && (
        <Card aria-labelledby="reports-when-weekdays" as="section" className="n3-reports__section">
          <ReportsCardTitle icon="calendar" id="reports-when-weekdays" tone="accent">Por día de la semana</ReportsCardTitle>
          <ReportsBars caption={view.weekdays.caption} items={view.weekdays.items} label="Operaciones por día de la semana" />
        </Card>
      )}
      {view.hours && (
        <Card aria-labelledby="reports-when-hours" as="section" className="n3-reports__section">
          <ReportsCardTitle icon="shift" id="reports-when-hours" tone="accent">Por hora</ReportsCardTitle>
          <ReportsBars caption={view.hours.caption} items={view.hours.items} label="Operaciones por hora" />
        </Card>
      )}
      <ReportsDetail id="reports-when-detail">
        {view.detail.map((section) => <ReportsSection icon="calendar" key={section.key} onNavigate={onNavigate} section={section} tone="accent" />)}
      </ReportsDetail>
      <ReportsNotes notes={view.notes} />
    </>
  );
}
